import { LogoId } from '../../../assets/images/images.types';

const logoIdImportMap = {
  empty: async () => '',
  [LogoId.LIBERIS_BLACK]: () => import('../../../assets/images/liberis-logo-black.png').then((f) => f.default),
  [LogoId.LIBERIS_WHITE]: () => import('../../../assets/images/liberis-logo-white.png').then((f) => f.default),
  [LogoId.WORLDPAY]: () => import('../../../assets/images/worldpay-logo.png').then((f) => f.default),
  [LogoId.WORLDPAY_BLACK]: () => import('../../../assets/images/worldpay-logo-black.png').then((f) => f.default),
  [LogoId.WORLDPAY_TOOLTIP_1]: () => import('../../../assets/images/worldpay-tooltip-1.png').then((f) => f.default),
  [LogoId.WORLDPAY_TOOLTIP_2]: () => import('../../../assets/images/worldpay-tooltip-2.png').then((f) => f.default),
  [LogoId.ELAVON_WHITE]: () => import('../../../assets/images/elavon-liberis-logo-white.svg').then((f) => f.default),
  [LogoId.ELAVON_BLACK]: () => import('../../../assets/images/elavon-liberis-logo-black.svg').then((f) => f.default),
  [LogoId.ELAVON_WHITE_MOBILE]: () =>
    import('../../../assets/images/elavon-liberis-logo-white-mobile.svg').then((f) => f.default),
  [LogoId.ELAVON_BLACK_MOBILE]: () =>
    import('../../../assets/images/elavon-liberis-logo-black-mobile.svg').then((f) => f.default),
  [LogoId.BARCLAYCARD_WHITE]: () => import('../../../assets/images/barclaycard-logo-white.png').then((f) => f.default),
  [LogoId.BARCLAYCARD_WHITE_MOBILE]: () =>
    import('../../../assets/images/barclaycard-logo-white-mobile.png').then((f) => f.default),
  [LogoId.BARCLAYCARD_BLACK]: () => import('../../../assets/images/barclaycard-logo-black.png').then((f) => f.default),
  [LogoId.BARCLAYCARD_BLACK_CENTERED]: () =>
    import('../../../assets/images/barclaycard-logo-black-centered.png').then((f) => f.default),
  [LogoId.KLARNA]: () => import('../../../assets/images/klarna-logo-black.png').then((f) => f.default),
  [LogoId.GLOBAL_PAYMENTS_BLACK]: () =>
    import('../../../assets/images/global-payments-logo-black.png').then((f) => f.default),
  [LogoId.GLOBAL_PAYMENTS_WHITE]: () =>
    import('../../../assets/images/global-payments-logo-white.png').then((f) => f.default),
  [LogoId.GLOBAL_PAYMENTS_BLACK_VERTICAL]: () =>
    import('../../../assets/images/global-payments-logo-black-vertical.png').then((f) => f.default),
  [LogoId.CLOVER]: () => import('../../../assets/images/clover.png').then((f) => f.default),
  [LogoId.CLOVER_BLACK]: () => import('../../../assets/images/clover-black.png').then((f) => f.default),
  [LogoId.NETS_LOGO_WHITE]: () => import('../../../assets/images/nets-logo-white.png').then((f) => f.default),
  [LogoId.NETS_SWEDEN]: () => import('../../../assets/images/nets-logo.png').then((f) => f.default),
  [LogoId.NETS_FINLAND]: () => import('../../../assets/images/nets-logo.png').then((f) => f.default),
  [LogoId.NETS_DENMARK]: () => import('../../../assets/images/nets-logo.png').then((f) => f.default),
};

export default logoIdImportMap;
